import React from 'react';
import PropTypes from 'prop-types';

import './module.css';

const JsonBackedTable = ({
  tableData
}) => {
  const headerKeys = Object.keys(tableData[0] ? tableData[0] : []);

  const rows = tableData.map((rowItem, rowIndex) => {
    const cols = headerKeys.map((colItem, colIndex) =>
      <td
        style={{whiteSpace: 'normal', wordWrap: 'break-word'}}
        key={colIndex}>
        { rowItem[colItem] }
      </td>
    );

    return <tr key={rowIndex}>{ cols }</tr>;
  });

  return (
    <table className="table table-fixed table-striped table-hover">
      <thead>
        <tr>
          {
            headerKeys.map((item, index) =>
              <th className="text-capitalize" key={index}>{ item }</th>
            )
          }
        </tr>
      </thead>
      <tbody>
        { rows }
      </tbody>
    </table>
  );
};

JsonBackedTable.propTypes = {
  tableData: PropTypes.array.isRequired
};

export default JsonBackedTable;
